<mat-expansion-panel class="{{colorName}}">
    <mat-expansion-panel-header>
        <span>{{contractIndex + 1}}. {{contract.promptBasic?.name || contract.question }}</span> @if (hasSummary) {
        <span class="summary-badge {{summaryColorName}}">
                {{ contract.analysisSummary?.shortAnswer }}
            </span> }
    </mat-expansion-panel-header>

    @if (hasSummary) {
    <div class="analysis-summary-section">
        <div class="summary-header">
            <mat-icon>analytics</mat-icon>
            <h3>{{'OverallAnalysisSummary' | translate }}</h3>
        </div>

        <div class="summary-content">
            <div class="summary-classification">
                <span class="label">{{'Classification' | translate }}:</span>
                <span class="badge {{summaryColorName}}">
                        {{ contract.analysisSummary?.shortAnswer }}
                    </span>
            </div>

            @if (contract.analysisSummary?.summary) {
            <div class="summary-text">
                <span class="label">{{'Summary' | translate }}:</span>
                <div class="summary-markdown">
                    <markdown [data]="contract.analysisSummary!.summary"></markdown>
                </div>
            </div>
            }
        </div>
    </div>

    <div class="divider"></div>

    <h4 class="detailed-header">{{'DetailedFileAnalysis' | translate }}</h4>
    }

    <table>
        <thead>
            <tr>
                <th>{{'FileName' | translate }}</th>
                @for (field of displayFields; track field) {
                    <th>{{ formatFieldLabel(field) }}</th>
                }
            </tr>
        </thead>
        <tbody>
            @for(f of contract.files; track f) {
            <tr>
                <td>{{ f.file }}</td>
                @for (field of displayFields; track field) {
                    <td>
                        @if (getFieldValue(f, field) !== null && getFieldValue(f, field) !== undefined) {
                            @if (field === 'summary' || field.includes('summary')) {
                                <markdown [data]="formatFieldValue(getFieldValue(f, field))"></markdown>
                            } @else {
                                <span>{{ formatFieldValue(getFieldValue(f, field)) }}</span>
                            }
                        } @else {
                            <span class="no-data">-</span>
                        }
                    </td>
                }
            </tr>
            }

        </tbody>
    </table>
</mat-expansion-panel>
